const { formatToTimeZone } = require('date-fns-timezone')

export default function formatTime(time) {
  if (time === '' || time === undefined) {
    return 'NA'
  }
  const format = 'HH:mm a'
  const time1 = new Date(time)
  var output = formatToTimeZone(time1, format, { timeZone: 'Asia/Kolkata' })
  if (output === 'Invalid Date') {
    output = time
  }
  return output
}
